// extracted by mini-css-extract-plugin
export default {"garden":"garden_garden__chWIC","girl":"garden_girl__FciPo","boy":"garden_boy__J2nRU"};